import { message } from 'antd'
import store from 'store'

import {
  acceptInvitation as onAcceptInvitation,
  invite as onInvite,
  login as onLogin,
  logout as onLogout,
  reset as onReset,
  singleLogin as onSingleLogin,
  updateProfile as updateProfileApi,
  verifyFacebookToken as onVerifyFacebookToken,
  verifyGoogleToken as onVerifyGoogleToken,
} from 'utils/apis'
import {
  inits,
  resetInits,
  setCompanies,
  setInits,
  setLoadedInit,
  setOptions,
  stopInit,
} from 'app-redux/inits/actions'
import * as actionTypes from 'app-redux/actionTypes'
import { clearAuthTokens, setRefreshToken, setSavedEmail, setToken } from 'utils/cookies'
import { teardownPushNotification } from 'utils/pushNotification'
import { setSelectedEndpoint } from 'app-redux/companies/actions'
import { setErrorLoginForm } from 'app-redux/loginForm/actions'
import { setUser } from 'app-redux/initSlice'
import { resetPaymentConnectKledoInfoDismiss } from 'app-redux/settings/actions'
import { resetCashier } from '../cashierSlice'

const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  ACTIVATE: 'user/ACTIVATE',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
}

export const tokenExpiredRedux = () => {
  return {
    type: actionTypes.TOKEN_EXPIRED,
  }
}

export const loginFailureRedux = (payload) => {
  return {
    type: actionTypes.USER_LOGIN_FAILURE,
    payload,
  }
}

export const login = (payload) => {
  return (dispatch) => {
    return onLogin(payload.email, payload.password, payload.remember_me)
      .then((response) => {
        if (response.data.success) {
          const { init, data } = response.data.data
          setToken(data.access_token, payload.remember_me)
          dispatch(setInits(init))
        } else {
          message.error(response.data.message)
        }
      })
      .catch(() => {
        dispatch(loginFailureRedux())
      })
  }
}

export const afterLoginHandler = (response, payload) => {
  return (dispatch) => {
    if (response.data.success) {
      const { data, companies, user } = response.data.data
      if (payload.email) {
        setSavedEmail(payload.email)
      }
      // JWT: Simpan access_token dan refresh_token dari response
      const tokenData = data?.data ?? data
      const accessToken = tokenData?.access_token ?? data?.access_token
      const refreshToken = tokenData?.refresh_token ?? data?.refresh_token
      if (accessToken) {
        setToken(accessToken)
      }
      if (refreshToken) {
        setRefreshToken(refreshToken)
      }
      if (companies?.length === 1) {
        // 1 perusahaan: JANGAN isi redux dari response login.
        // Hanya pilih endpoint perusahaan (sama seperti memilih perusahaan manual) -
        // ambil dari companies (array) elemen pertama, lalu hit /inits sebagai
        // SATU-SATUNYA sumber data redux.
        dispatch(setSelectedEndpoint(companies[0].endpoint))
        dispatch(inits())
      } else {
        if (response.data?.data?.endpoint) {
          dispatch(setSelectedEndpoint(response.data?.data?.endpoint))
        }
        dispatch(setUser(user))
        dispatch(setCompanies({ companies }))
        dispatch(stopInit())
        dispatch(setLoadedInit())
      }
    } else {
      message.error(response.data.message)
    }
  }
}

export const singleLogin = (payload) => {
  return (dispatch) => {
    dispatch(setErrorLoginForm(null))

    return onSingleLogin(payload.email, payload.password, payload.remember_me)
      .then((response) => {
        dispatch(afterLoginHandler(response, payload))
      })
      .catch(() => {
        dispatch(loginFailureRedux())
      })
  }
}

export const verifyGoogleToken = (payload) => {
  return (dispatch) => {
    dispatch(setErrorLoginForm(null))

    return onVerifyGoogleToken(payload)
      .then((response) => {
        if (response.data.success) {
          dispatch(afterLoginHandler(response, { email: response.data.data.user.email }))
        } else {
          dispatch(setErrorLoginForm(response.data.message))
        }
      })
      .catch((e) => {
        dispatch(loginFailureRedux())
        if (e && e.data && e.data.message) {
          dispatch(setErrorLoginForm(e.data.message))
        }
      })
  }
}
export const verifyFacebookToken = (payload) => {
  return (dispatch) => {
    dispatch(setErrorLoginForm(null))

    return onVerifyFacebookToken(payload)
      .then((response) => {
        if (response.data.success) {
          dispatch(afterLoginHandler(response, { email: response.data.data.user.email }))
        } else {
          dispatch(setErrorLoginForm(response.data.message))
        }
      })
      .catch((e) => {
        dispatch(loginFailureRedux())
        if (e && e.data && e.data.message) {
          dispatch(setErrorLoginForm(e.data.message))
        }
      })
  }
}

export const invite = (payload) => {
  return (dispatch) => {
    return onInvite(payload)
      .then((response) => {
        if (response.data.success) {
          const { init, data } = response.data.data
          store.remove('app.endpoint')
          setToken(data.access_token, data.expires_at)
          dispatch(setInits(init))
          dispatch(stopInit())
          return true
        }
        message.error(response.data.message)
        return false
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export const acceptInvitation = (payload) => {
  return (dispatch) => {
    return onAcceptInvitation(payload)
      .then((response) => {
        if (response.data.success) {
          const { init, data } = response.data.data
          store.remove('app.endpoint')
          setToken(data.access_token, data.expires_at)
          dispatch(setInits(init))
          dispatch(stopInit())
          return true
        }
        message.error(response.data.message)
        return false
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export const reset = ({ payload, onFinish }) => {
  return (dispatch) => {
    return onReset(payload)
      .then((response) => {
        if (response.data.success) {
          const { init, data, companies, user } = response.data.data
          store.remove('app.endpoint')
          setToken(data.access_token, data.expires_at)
          if (init) {
            dispatch(setInits(init))
          } else {
            dispatch(setUser(user))
            dispatch(setCompanies({ companies }))
          }
          dispatch(stopInit())
        } else {
          message.error(response.data.message)
        }
        onFinish()
      })
      .catch((e) => {
        console.log(e)
        message.error('Error reset')
        onFinish()
      })
  }
}

export const logoutRedux = () => {
  return {
    type: actionTypes.USER_LOGOUT,
  }
}

export const logout = () => {
  return (dispatch) => {
    // dispatch(startInit())
    return onLogout()
      .then((response) => {
        if (response.data.success) {
          // Dihapus dulu previous path dan selected endpoinnya
          store.remove('app.previousPathname')
          store.remove('app.endpoint')
          // Dihapus seluruh token (access + refresh)
          clearAuthTokens()
          // Payload logout (berisi `device_token`) sudah terkirim; baru sekarang
          // token FCM perangkat ini diputus & dibersihkan.
          teardownPushNotification()
          // Reset reduxnya
          dispatch(setSelectedEndpoint(null))
          dispatch(resetInits())
          dispatch(setOptions(response.data.data))
          dispatch(logoutRedux())
          dispatch(resetCashier())
          dispatch(resetPaymentConnectKledoInfoDismiss())
        } else {
          message.error(response.data.message)
        }
        // dispatch(stopInit())
      })
      .catch(() => {
        message.error('Logout failure!')
        // Tetap hapus token lokal agar user bisa login ulang
        clearAuthTokens()
        teardownPushNotification()
        dispatch(setSelectedEndpoint(null))
        dispatch(resetInits())
        dispatch(logoutRedux())
        dispatch(resetPaymentConnectKledoInfoDismiss())
      })
  }
}

export const updateProfileRedux = (payload) => {
  return {
    type: actionTypes.USER_UPDATE_PROFILE,
    payload,
  }
}

export const updateProfile = (payload) => {
  return (dispatch) => {
    return updateProfileApi(payload).then((response) => {
      dispatch(updateProfileRedux(response.data.data))
      return response
    })
  }
}

export const tokenExpired = () => {
  return (dispatch) => {
    // Dihapus dulu previous path dan selected endpoinnya
    store.remove('app.previousPathname')
    store.remove('app.endpoint')
    // Dihapus seluruh token (access + refresh)
    clearAuthTokens()
    dispatch(setSelectedEndpoint(null))
    dispatch(resetInits())
    dispatch(tokenExpiredRedux())
  }
}

export default actions
